import { useQuery } from 'hooks'
import { useMemo } from 'react'


const useAppeals = () => {

  const statisticsOptions = useMemo(() => ({
    url: '/ajax.php?action=getAll&stat=1&v=2',
    modifyResult: ({ statistics }) => {
      const { total: appealsTotal, inWork: appealsInWork, closed: appealsClosed, removed } = statistics

      return {
        appealsTotal: String(Number(appealsTotal) - Number(removed)),
        appealsInWork,
        appealsClosed,
      }
    },
  }), [])

  const {
    data: statistics,
    isFetching: isStatisticsFetching,
    errors: statisticsErrors,
  } = useQuery<{ appealsTotal, appealsInWork, appealsClosed }>(statisticsOptions)
  const { appealsTotal, appealsInWork, appealsClosed } = statistics || {}

  const appealsOptions = useMemo(() => ({
    url: '/ajax.php?action=getCarousel&last=3&photoFile=1',
    modifyResult: ({ all = [] }) => {
      return all.map(({ photo }) => ({
        image: __DEV__ ? 'https://test.rosatom.city/' + photo : photo,
      }))
    },
  }), [])

  const { data: appeals, isFetching: isAppealsFetching, errors: appealsErrors } = useQuery(appealsOptions)

  return { appeals, appealsTotal, appealsInWork, appealsClosed }
}

export default useAppeals